// Client/src/AssetClassContext.jsx
// Renders high-level asset class & market context based on result.asset_class_context

import React from "react";
import { getReportLabels } from "./reportI18n";

/**
 * Split summary text into paragraphs using blank lines.
 */
function splitSummary(summary) {
  if (!summary) return [];
  return summary
    .split(/\n{2,}/) // split on one or more blank lines
    .map((s) => s.trim())
    .filter(Boolean);
}

export default function AssetClassContext({ assetClassContext, reportLanguageCode = "en" }) {
  if (!assetClassContext || typeof assetClassContext !== "object") {
    return null;
  }

  const {
    summary,
    market_phase,
    strengths,
    weaknesses,
    data_confidence,
  } = assetClassContext;

  const hasAnyContent =
    (summary && summary.trim().length > 0) ||
    (market_phase && market_phase.trim().length > 0) ||
    (Array.isArray(strengths) && strengths.length > 0) ||
    (Array.isArray(weaknesses) && weaknesses.length > 0);

  if (!hasAnyContent) {
    return null;
  }

  const labels = getReportLabels(reportLanguageCode);
  const summaryParagraphs = splitSummary(summary);
  const strengthsList = Array.isArray(strengths) ? strengths : [];
  const weaknessesList = Array.isArray(weaknesses) ? weaknesses : [];

  const confidenceLabel =
    data_confidence === "high"
      ? "high"
      : data_confidence === "medium"
      ? "medium"
      : data_confidence === "low"
      ? "low"
      : null;

  return (
    <section className="card asset-class-context-card" style={{ marginBottom: "24px" }}>
      <h3 style={{ marginTop: 0, marginBottom: "8px" }}>
      2. {labels.assetClassContext}
    </h3>
      <div
        className="asset-class-context-panel"
        style={{
          borderRadius: "12px",
          padding: "16px 20px",
          background: "rgba(99, 102, 241, 0.06)",
          border: "1px solid rgba(99, 102, 241, 0.18)",
        }}
      >
        {summaryParagraphs.length > 0 && (
          <div style={{ marginTop: 0, marginBottom: "12px" }}>
            {summaryParagraphs.map((p, idx) => (
              <p
                key={idx}
                style={{
                  marginTop: idx === 0 ? 0 : "8px",
                  marginBottom: idx === summaryParagraphs.length - 1 ? 0 : "8px",
                }}
              >
                {p}
              </p>
            ))}
          </div>
        )}
                    {market_phase && (
              <p style={{ margin: 0, marginBottom: "16px" }}>
                <strong>{labels.currentMarketPhase}:</strong>{" "}
                <span>{market_phase}</span>
              </p>
            )}
      <div
  className="asset-class-context-columns"
  style={{
    display: "grid",
    gridTemplateColumns: "minmax(0, 1.2fr) minmax(0, 1fr)",
    gap: "16px",
  }}
>
  <div className="asset-class-context-column">
    {strengthsList.length > 0 && (
      <>
        <p style={{ marginBottom: "4px" }}>
          <strong>{labels.structuralStrengths}:</strong>
        </p>
        <ul style={{ marginTop: 0, paddingLeft: "18px" }}>
          {strengthsList.map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
        </ul>
      </>
    )}
  </div>

  <div className="asset-class-context-column">
    {weaknessesList.length > 0 && (
      <>
        <p style={{ marginBottom: "4px" }}>
          <strong>{labels.structuralWeaknesses}:</strong>
        </p>
        <ul style={{ marginTop: 0, paddingLeft: "18px" }}>
          {weaknessesList.map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
        </ul>
      </>
    )}
  </div>
</div>

        {confidenceLabel && (
  <p className="muted small" style={{ marginTop: "12px", marginBottom: 0 }}>
  {labels.marketContextNote}
</p>
        )}
      </div>
    </section>
  );
}
